import { Schema } from "effect";

// GitHub entity IDs - prevent mixing different GitHub-related IDs

export const GitHubInstallationId = Schema.String.pipe(
  Schema.brand("GitHubInstallationId")
);
export type GitHubInstallationId =
  typeof GitHubInstallationId.Type;

export const GitHubIssueId = Schema.String.pipe(
  Schema.brand("GitHubIssueId")
);
export type GitHubIssueId = typeof GitHubIssueId.Type;

export const GitHubRepositoryId = Schema.String.pipe(
  Schema.brand("GitHubRepositoryId")
);
export type GitHubRepositoryId =
  typeof GitHubRepositoryId.Type;

/**
 * GitHub issue number (e.g., 123, 456)
 */
export const GitHubIssueNumber = Schema.Finite.pipe(
  Schema.brand("GitHubIssueNumber")
);
export type GitHubIssueNumber =
  typeof GitHubIssueNumber.Type;

/**
 * GitHub repository owner (user or organization name)
 * (e.g., "facebook", "microsoft", "my-org")
 */
export const RepositoryOwner = Schema.String.pipe(
  Schema.brand("RepositoryOwner")
);
export type RepositoryOwner = typeof RepositoryOwner.Type;

/**
 * GitHub repository name (without owner)
 * (e.g., "react", "vscode", "my-repo")
 */
export const RepositoryName = Schema.String.pipe(
  Schema.brand("RepositoryName")
);
export type RepositoryName = typeof RepositoryName.Type;
